import { Label } from '@pixacare/domain';
import { StoreLabelPack } from './models/store-label-pack';

export type LabelsState = {
  labels: {
    [labelId: number]: Label;
  };
  userLabels: number[];
  labelPacks: {
    [labelPackId: number]: StoreLabelPack;
  };
};

export const initialLabelsState: LabelsState = {
  labels: {},
  labelPacks: {},
  userLabels: [],
};
